import { useParams } from 'wouter';

import useAuthor from '../../hooks/useAuthor';
import { useAuthorSchema } from '../../hooks/useMicroformats';
import { useAuthorUrlGenerator } from '../../hooks/useUrlGenerator';

import Metadata from './Metadata';
import NotfoundMetadata from './NotfoundMetadata';

function AuthorMetadata() {
    const { author: slugParam = null } = useParams<{ author?: string }>();
    const { author = null, notFound = false } = useAuthor(slugParam);
    const url = useAuthorUrlGenerator();
    const authorSchema = useAuthorSchema(author);
    const trackingVariables = {
        authors: [author],
    };

    if (notFound) {
        return <NotfoundMetadata />;
    }

    if (author === null) {
        return null;
    }

    const { name, shortDescription, slug, image } = author;
    const pageUrl = url({
        slug,
    });

    return (
        <Metadata
            title={name}
            description={shortDescription}
            image={image}
            url={pageUrl}
            microformats={authorSchema !== null ? [authorSchema] : []}
            pageType="author"
            rssUrl={`${pageUrl}.rss`}
            atomUrl={`${pageUrl}.atom`}
            trackingVariables={trackingVariables}
        />
    );
}

export default AuthorMetadata;
